import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Loading } from "@/components/atoms";
import { GeneralFooter, GeneralHeader, SignUpSteps } from "@/components/organisms";
import { useProviderCode, useSiteConfig } from "@/hooks";
import { useLazyVerifyProviderQuery } from "@/redux/apis/auth/authApi";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setActiveOperator } from "@/redux/slices/operator/operatorSlice";
import { activeOperatorSelector } from "@/redux/slices/operator/selectors";
import { Restricted } from "../Restricted/Restricted";

export const SignUp = () => {
  const dispatch = useAppDispatch();
  const { domain, apiUrl } = useSiteConfig();
  const providerCode = useProviderCode();
  const operator = useAppSelector(activeOperatorSelector);
  const [verify] = useLazyVerifyProviderQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if (providerCode) {
      verify({ providerCode, apiUrl })
        .unwrap()
        .then((res) => {
          dispatch(setActiveOperator(res));
        })
        .catch((e) => {
          console.warn("(SignUp) Error verifying provider:", {
            providerCode,
            error: e,
          });
          navigate("/404");
        });
    } else if (!operator) {
      verify({ providerCode: domain, apiUrl })
        .unwrap()
        .then((res) => {
          dispatch(setActiveOperator(res));
        })
        .catch((e) => {
          console.warn("(SignUp) Error verifying provider:", {
            providerCode: domain,
            error: e,
          });
          navigate("/404");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerCode]);

  if (!operator) return <Loading />;

  const signUpEnabled = operator.singleTenant;

  return (
    <div className="flex min-h-screen flex-col overflow-hidden md:flex-row">
      <div className="relative flex flex-1 flex-col">
        <GeneralHeader action="login" />
        {signUpEnabled ? (
          <Container className="flex w-full max-w-[1040px] flex-1 justify-center gap-5 px-5 py-8 md:py-[100px]">
            <SignUpSteps />
          </Container>
        ) : (
          <Restricted />
        )}
        <GeneralFooter />
      </div>
    </div>
  );
};
